
angular.module('ui2.0Directives')
    .directive('viewDropDown', ['$rootScope', '$http', '$location','$q','$timeout', function ($rootScope, $http, $location,$q,$timeout) {
        return {
            restrict: "E",
            templateUrl: $rootScope.createHtmlUrl("ui2.0/directiveTemplates/viewDropDown.html"),
            link: function ($scope, element, attrs) {
                $scope.viewType = 'byMe';
                $scope.viewTypeToSave = 'private'
                $scope.systemDefault = false;
                $scope.saveViewLiText = intl_msg[27944];
                $scope.editViewObj = null;
                $scope.urlController = $scope.isReportFilter?"reportRenderer":"listRenderer"
                $scope.saveMode = true;
                $scope.showLimitExceedMessage = "";
                $scope.searchText = "";
                $scope.defaultView = {};
                let alreadySavedView = false;
                $scope.bulkThroughJourney = !$rootScope.updateBulkListing;
                $scope.firstLoad = false;
                $scope.isIntermittentState = window.location.href.includes('uuid');
                $scope.radio = {
                    saveType: {'value': 'private'},
                    viewType: {'value': 'byMe'}
                }
                //to check if view is shared for 1st time
                $scope.viewSharedFirst = true;
                $scope.viewDd = false;
                $scope.resultViewsStatus = $rootScope.isCognitiveListing ? window.resultPageListingData?.[Number(listId)].viewStatus : "None";
                $scope.statusViewName = $rootScope.isCognitiveListing ? window.resultPageListingData?.[listId].statusViewName || 'Current view' : '';
                // $scope.resultPageListing = window.location.href.indexOf("/search/result") > -1 ? true : false;
                // To toggle the viewDropDown
                $scope.toggleViewDropDown = function(bool, relativePosition){
                    $scope.rolePublicFilter = $scope.layoutData.rolePublicFilter ?? JSON.parse(window.localStorage.getItem("sideLayoutData"))?.data?.rolePublicFilter;
                    if(bool == true){
                        $scope.isReportFilter && $scope.initToggleReportFilters(event,true);
                        $scope.viewDd = !$scope.viewDd
                        $('.viewSection').removeClass('selected');
                        $('.preferViewSection').css({"opacity": 1, "visibility": "visible", "display": "block", "z-index": 999999});
                    }
                    else{
                        $scope.viewDd = false;
                    }
                    setTimeout(function () {
                        document.getElementById("createViewSearch") && document.getElementById("createViewSearch").focus();
                    }, 20);
                    if($rootScope.isCognitiveListing) {
                        if(relativePosition) {
                            const {leftOffsetModRibbon, topOffsetModRibbon, heightModRibbon} = $scope.getElementPosition()
                            $("#saved_view_list").css({
                                "position": "fixed",
                                "left": leftOffsetModRibbon + "px",
                                "top": topOffsetModRibbon + heightModRibbon + 3 + "px"
                            });
                            const isSelected = $(".viewSaveButton").hasClass("selected");
                            isSelected ? $(".viewSaveButton").removeClass("selected") : $(".viewSaveButton").addClass("selected");
                        } else {
                            $(".viewSaveButton").removeClass("selected");
                        }
                    }
                }

                //To toggle SaveView-Box
                $scope.saveViewOpen=false;
                $scope.openSavedView=function () {
                    const leftOffsetModRibbon = document.getElementsByClassName("modifiedStat")[0].offsetLeft;
                    const topOffsetModRibbon = document.getElementsByClassName("modifiedStat")[0].offsetTop;
                    const heightModRibbon = document.getElementsByClassName("modifiedStat")[0]?.getBoundingClientRect()?.height;
                    $("#saveDD_share_filter").css({"left": leftOffsetModRibbon + "px","top": topOffsetModRibbon + heightModRibbon + 3 +  "px"});
                    $scope.saveViewOpen = !$scope.saveViewOpen;
                }
                $scope.closeSavedView=function (e) {
                    if(e.target.className.indexOf("modifiedStat-span") >  -1)
                        return;

                    $scope.saveViewOpen=false;
                }

                $scope.getElementPosition = (elementTag = 'viewSaveButton') => {
                    const element = document.getElementsByClassName(elementTag)[0];
                    const viewportOffset = element.getBoundingClientRect();
                    const leftOffsetModRibbon = viewportOffset.left;
                    const topOffsetModRibbon = viewportOffset.top;
                    const heightModRibbon = viewportOffset.height;
                    return {
                        leftOffsetModRibbon,
                        topOffsetModRibbon,
                        heightModRibbon
                    }
                }

                // View popup for result page
                $scope.openResultSavedView=function () {
                    if ($(".viewSaveButton").hasClass("selected")) {
                        $(".viewSaveButton").removeClass("selected");
                        return;
                    }
                    const element = document.getElementsByClassName("viewSaveButton")[0];
                    const viewportOffset = element.getBoundingClientRect();
                    const scale150 = window.devicePixelRatio === 1.5;
                    const leftOffsetModRibbon = viewportOffset.left;
                    const topOffsetModRibbon = viewportOffset.top;
                    const heightModRibbon = viewportOffset.height;
                    const top = topOffsetModRibbon + heightModRibbon + (scale150 ? 42 : 3);
                    const left = leftOffsetModRibbon + (scale150 ? 52 : 0);
                    $("#saveDD_share_filter").css({"position": "fixed", "left": left + "px","top": top + "px"});
                    $scope.saveViewOpen = !$scope.saveViewOpen;
                    $scope.toggleViewDropDown(false);
                    // $(".viewSaveButton").addClass("selected");
                }

                //To toggle dropDown inside favDD
                $scope.doubleDropDown=false;
                $scope.doubleDropDownToggle = function(e){
                    e.stopPropagation();
                    $scope.doubleDropDown = !$scope.doubleDropDown;
                    setTimeout(()=>{
                        var elm = e.currentTarget.nextElementSibling;
                        var ddElm = elm.children[0];
                        var ddElmWidth = ddElm?.getBoundingClientRect()?.width;
                        var calPos = SirionUtils.getElmPosRespectToParent(elm,'#viewdd');
                        //Height of the li is 36,  30 is added to top to handle problem when last li opts are opened
                        $scope.doubleDropDown ? $(ddElm).css({"top":calPos.elementTopVP + 30, "left": (calPos.elementLeftVP + 36) -  ddElmWidth ,"opacity": 1}) : !$scope.doubleDropDown;
                    })
                }
                $scope.hoverInteraction=function(e,isVisibleHoverInteraction){
                    if($(".listing_name_container:hover").length && isVisibleHoverInteraction && !$(".toolTip_favDD_container:hover").length && !$rootScope.isCognitiveListing){
                        $scope.hoverInteractionBool = true;
                    }
                    else{
                        $scope.hoverInteractionBool = false;
                    }
                }
                $scope.nameToSave = {"value": ""};
                if (window.contractId) {
                    let contractId = window.contractId;
                } else {
                    let contractId = "";
                }
                if (window.relationId) {
                    let relationId = window.relationId;
                } else {
                    let relationId = "";
                }
                if (window.vendorId) {
                    let vendorId = window.vendorId;
                } else {
                    let vendorId = "";
                }
                var updateViewListing = $scope.$on('updateViewListing', function (event, data,filterCallback,isPin) {
                    $scope.updateViewListing(data, true, true,filterCallback,isPin);
                });
                var statModifiedFunc =  $scope.$on('statModifiedFunc', function (event,data) {
                    $scope.statModifiedFunc(data);
                });
                var updateSetting = $scope.$on('updateSetting', function (event) {
                    $scope.updateSetting(event, true);
                });
                var cancelSetting = $scope.$on('cancelSetting', function (event) {
                    $scope.cancelSetting(event);
                });
                $scope.$on('$destroy', function() {
                    updateViewListing();
                    statModifiedFunc();
                    updateSetting();
                    cancelSetting();
                });
                $scope.statModifiedFunc = (data) => {
                    const {hasChange=true} = data || {};
                    if (_.isEmpty($scope.currentView)) {
                        $scope.myViewChanged = false;
                    } else {
                        var publicVisibility = ["Shared By Me", "Shared With Me"].indexOf($scope.currentView.visibility) > -1;
                        var viewType = $scope.currentView.visibility;
                        if ((publicVisibility && viewType === "Shared With Me") || $rootScope.isCognitiveListing) {
                            $scope.myViewChanged = false;
                        } else {
                            $scope.myViewChanged = true;
                        }
                    }
                    // angular.element(".modifiedStat").show();
                    if($rootScope.isCognitiveListing && window.resultPageListingData[listId].viewStatus === "Saved") {
                        window.resultPageListingData[listId].viewStatus = "SavedAndModified";
                        $scope.resultViewsStatus = "SavedAndModified";
                    }
                    if(hasChange) {
                        $scope.viewModified = true;
                        $scope.openViewModifiedRibbon = true;
                    }
                }
                $scope.setViewModified = (value) => {
                    $scope.resultViewsStatus = value
                }
                $scope.updateViewListing = (data, changeDefault, firstLoad,filterCallback,isPin) => {
                    $rootScope.isPin = isPin;
                    $scope.firstLoad = firstLoad;
                    let systemDefaultPreferred = true;
                    $scope.noByMeViews = true;
                    angular.element('listingPanelLeft').find(".savedViewDD li:not('.noViews, .resetView')").remove();
                    let createdByViewsLength = data.filter(function (view) {
                        return view.visibility != "Shared With Me"
                    }).length;
                    if (createdByViewsLength) {
                        $scope.noByMeViews = false;
                    }
                    $scope.allViews = data;
                    $scope.idInView = null;
                    $scope.prevObj = null;
                    $scope.privateCollapseIconClass = "icon-down-arrow";
                    $scope.publicCollapseIconClass = "icon-down-arrow";
                    $scope.allViews.sort((view1, view2) => view2.isdefault - view1.isdefault);
                    let view = $scope.allViews.find(function (view) {
                        return view.isdefault;
                    });

                    if( $rootScope.isMiraPageActive) {
                        $rootScope.listingSkeletonLoader = false;
                        view = null;
                        if(window.listDataCallInitiated) {
                            delete window.listDataCallInitiated;
                        }
                    }

                    if (firstLoad && !_.isEmpty(view) && !$rootScope.fromJobSchedular) {
                        if ($scope.initFilters){
                            $scope.initFilters().then(function(){
                                $rootScope.loadClauseLibraryDefInstance && $rootScope.loadClauseLibraryDefInstance.resolve("Filter compiled!");
                                filterCallback &&  filterCallback();
                            });
                        }
                    }
                    if(firstLoad && window.location.href.includes("uuid") && _.isEmpty(view)) {
                        $scope.systemDefault = true;
                        $scope.showResetView = false;
                        $scope.defaultView = {};
                    }
                    if (changeDefault && !(firstLoad && window.location.href.includes("uuid"))) {
                        if (_.isEmpty(view)) {
                            $scope.systemDefault = true;
                            $scope.showResetView = false;
                            $scope.defaultView = {};
                        } else {
                            $scope.systemDefault = false;
                            $scope.defaultView = view;
                            $scope.showResetView = false;

                            if (firstLoad) {
                                $scope.currentView = $rootScope.showPreferredViewForcefully ? {} : view;
                                if ($location.search().insightComputationId || !_.isEmpty(window.multiEntityItems) || window.conditionCheck.isSearchResultPage() ) {
                                    $scope.currentView = {};
                                }
                                $scope.showResetView = false;
                            }
                        }
                    }


                    $scope.showLimitExceedMessage = createdByViewsLength >= 40 ? intl_msg[28988].replace("%s", "40") : "";

                }
                $scope.getPinTitle = (view) => {
                    return (view && view.pinned) ? intl_msg[25736] : intl_msg[25735];
                }
                $scope.setPreferredView = (viewType) => {
                    if (viewType == "byMe") {
                        $scope.viewType = 'byMe';
                        // angular.element('#byMeViewBtnRadio').prop("checked", true);
                        $scope.radio.viewType.value = 'byMe';
                    } else {
                        $scope.viewType = 'others';
                        // angular.element('#othersViewBtnRadio').prop("checked", true);
                        $scope.radio.viewType.value = 'others';
                    }
                }
                $scope.toggleHoverState = (e, mouseEnter) => {
                    let element = angular.element(e.target);
                    let doubleDdElm = element.children(".doubleDD");
                    if (mouseEnter) {
                        element.addClass('hoverState');
                    } else {
                        element.removeClass('hoverState');
                        if(doubleDdElm.length < 1){
                            $(doubleDdElm).css({"opacity": 0})
                        }
                        $scope.doubleDropDown=false;
                    }
                }
                $scope.toggleDropDown = (e, viewId) => {
                    e.stopPropagation();
                    if (!$scope.prevObj) {
                        angular.element("li[data-mod-id=" + viewId + "]").find('.toggleDropDown').show();
                    } else {
                        if (viewId == $scope.prevObj) {
                            angular.element("li[data-mod-id=" + viewId + "]").find('.toggleDropDown').toggle();
                        } else {
                            angular.element("li[data-mod-id=" + $scope.prevObj + "]").find('.toggleDropDown').hide();
                            angular.element("li[data-mod-id=" + viewId + "]").find('.toggleDropDown').show();
                        }
                    }
                    $scope.prevObj = viewId;
                    let heightDiff = ($("#viewdd").offset().top + $("#viewdd").height()) - ($("li[data-mod-id=" + $scope.prevObj + "]").offset().top + $("li[data-mod-id=" + $scope.prevObj + "]").outerHeight());
                    if (angular.element(".by-me").scrollTop() + 80 < angular.element(".by-me").innerHeight()) {
                        if (heightDiff && heightDiff < 0) {
                            let scrollAmount = 100 - heightDiff;
                            setTimeout(function () {
                                angular.element(".by-me").stop().animate({scrollTop: scrollAmount}, 'slow');
                            });

                        } else if (heightDiff && heightDiff < 80) {
                            let scrollAmount = 100 - heightDiff;
                            setTimeout(function () {
                                angular.element(".by-me").stop().animate({scrollTop: scrollAmount}, 'slow');
                            });

                        }
                    }


                }

                $scope.getClassForLi = (view) => {
                    return view.isdefault ? 'isDefaultView' : '';
                }

                $scope.privateView = (view) => {
                    return view.visibility === 'My View';
                }

                $scope.publicView = (view) => {
                    return view.visibility === 'Shared By Me';
                }

                $scope.othersView = (view) => {
                    return view.visibility === 'Shared With Me';
                }

                $scope.switchPrivateDiv = (e) => {
                    e.stopPropagation();
                    $(".by-me").css("overflow","auto");
                    $scope.privateCollapseIconClass = $scope.privateCollapseIconClass === 'icon-down-arrow' ? 'icon-Right-Arrow' : 'icon-down-arrow';
                    // angular.element(e.target).find("#privateDiv").toggle();
                    angular.element("#privateDiv").toggle();
                }

                $scope.switchPublicDiv = (e) => {
                    e.stopPropagation();
                    $(".by-me").css("overflow","auto");
                    $scope.publicCollapseIconClass = $scope.publicCollapseIconClass === 'icon-down-arrow' ? 'icon-Right-Arrow' : 'icon-down-arrow';
                    angular.element("#publicDiv").toggle();
                }

                $scope.updateUUidUrl = (dataToSend) => {
                    if(!window.location.href.includes('listRender')) return;
                    if(window.preventUUIDupdate) {
                        window.preventUUIDupdate = false;
                        return;
                    }
                    let updatedDataSend = JSON.parse(dataToSend)
                    let uniqueId = window.SirionUtils.generateUniqueID();
                    window.location.replace(window.SirionUtils.addParameterToUrl(window.location.href, 'uuid', uniqueId));
                    const viewScope  = $("view-drop-down").scope();
                    window.redirectionUniqueId = uniqueId;
                    const updatedUrl = `/v3/listRenderer/cache-list-meta-data/${uniqueId}?isFirstCall=false&isViewModified=${viewScope.viewModified || false}`
                    updatedDataSend = JSON.stringify(updatedDataSend);

                    $.ajax({
                        dataType: 'json',
                        contentType: "application/json;charset=UTF-8",
                        type: 'POST',
                        timeout: 150000,
                        data: updatedDataSend,
                        url: updatedUrl
                    })

                    if(!window.globalIdMapper) {
                        window.globalIdMapper = {}
                    }
                    window.globalIdMapper[uniqueId] = updatedDataSend
                    localStorage.setItem('globalIdMapper', JSON.stringify(window.globalIdMapper));
                    window.listResponse = JSON.parse(updatedDataSend);
                }

                $scope.loadView = (e,view, privateViewId, retainSort = false) =>{
                    if($rootScope.isCognitiveListing) {
                        let viewRoute = `${window.location.origin}${window.location.pathname}#/listRender/${listId}`;
                        viewRoute += view && view?.id ? `?preferredViewId=${view.id}` : '';
                        window.open(viewRoute, "_blank");
                        return;
                    }
                    window.prefViewDetail = {};
                    $scope.isShimmer = true;
                    const filterScope = $("filters").scope();
                    let listSc = $('#contentWrap').length ? $('#contentWrap').scope() : null;
                    listSc.searchEntityItems = false;
                    window.multiEntityItems = undefined;
                    window.multiEntityFilterFromBackend = null;
                    if(filterScope) filterScope.isFirstCall = false;
                    let url = '';
                    if(privateViewId){
                        $scope.privateViewShared = true;
                        url = apiVersioning.getApiDynamicVersion($scope.urlController + "_userListMetaData",listId )  + "/userListMetaData?preferenceId=" + privateViewId + "&contractId=" + contractId + "&publicVisibility=" + false +"&sharedView=true";
                    }else{
                        $scope.privateViewShared = false;
                        if (e) {
                            e.stopPropagation();
                            if (angular.element(e.currentTarget).hasClass('disabledClick') && !$rootScope.showPreferredViewForcefully) {
                                return;
                            }
                        }
                        view && ($scope.currentViewUrl = window.location.href + "?preferredViewId=" + view.id);
                        $scope.viewDd = false;
                        $rootScope.insightsCollapsed = true;
                        $rootScope.savedViewLoaded = true;
                        $rootScope.viewLoaded = true;
                        $scope.searchText = "";
                        if ((angular.element(".viewSection").hasClass('editMode'))) {
                            angular.element(".editMode").addClass("selected");
                        }
                        if (!(angular.element(".viewSection").hasClass('editMode'))) {
                            angular.element(".viewSection").removeClass("selected");
                        }
                        //angular.element("#viewdd").css({"opacity":0,"visibility":"hidden","display":"none","z-index":-1});
                        if (typeof BU != "undefined" && e && BU.cancelAction && angular.element(e.currentTarget).closest("#bulkPlaceHolderList").length == 0) {
                            BU.cancelAction(true, $scope.isShimmer); // Case for resetting the bulk action state
                        }
                        if (!view) {
                            $scope.currentView = {};
                            $scope.defaultView = {};
                            $scope.showResetView = false;
                            window.systemDefaultView = true;
                            $scope.systemDefaultViewLoaded = true;
                            angular.element(".resetView").addClass('disabledClick');
                            commonUtil.unPinnedForSystemDefaultView();
                            if($(".react-filter-btn").length && window.reactFilterLoaded) {
                                let propsToPass = {
                                    systemResetViewClause : false,
                                }
                                window.sarc.channelBroadcast("loadReactFiltersForDefaultView", {
                                    actionType: 'cancelSettingsForSystemView',
                                    systemResetView : true,
                                    payload : propsToPass,
                                }, 'loadReactFiltersForDefaultViewSubscription')
                            } else {
                                setTimeout(function () {
                                    angular.element(".reset ").each(function () {
                                        angular.element(this).click();
                                    });
                                });
                            }
                            angular.element(".disabledClick").removeClass("disabledClick");
                            $timeout(() => {
                                $scope.viewModified = false;
                            },100)
                            return;
                        }
                        else {
                            $scope.systemDefaultViewLoaded = false;
                            isDefaultViewVSet = false;
                            $scope.currentView = view;
                            if ($scope.defaultView && $scope.defaultView.id == $scope.currentView.id) {
                                $scope.showResetView = false;
                            }
                            else {
                                $scope.showResetView = true;
                            }
                        }
                        angular.element(".disabledClick").removeClass("disabledClick");
                        angular.element("li[data-mod-id=" + view.id + "]").addClass('disabledClick');
                        (e && e.currentTarget) ? setTimeout(function () {
                            $scope.$emit("listing skeleton toggle", true, false)
                        }) : null;
                        commonUtil.markActiveView(view.id);
                        let publicVisibility = ["Shared By Me", "Shared With Me"].indexOf(view.visibility) > -1 ? true : false;
                        url = apiVersioning.getApiDynamicVersion($scope.urlController + "_userListMetaData",listId ) + "/userListMetaData?preferenceId=" + view.id + "&contractId=" + contractId + "&publicVisibility=" + publicVisibility;
                    }
                    $http.post(url).then(function successCallback(response) {
                        let data = response.data;
                        if(!data){
                            var newUrl = window.location.href;
                            var index = newUrl.indexOf('?preferredViewId');
                            if(index != -1) {
                                newUrl = newUrl.slice(0,index)
                            }
                            window.location.href = newUrl
                            Toaster.create(intl_msg[31662] || "Default view is applied as earlier view is no more available");
                            return;
                        }
                        // Guard against invalid/empty filterJson before parsing
                        if(!data.filterJson || data.filterJson === "null" || data.filterJson === "undefined"){
                            window.systemWarning && window.systemWarning("View Corrupted filterJson",data);
                            data.filterJson = stringify_datatable_json(true);
                        }
                        let fJson = JSON.parse(data.filterJson);
                        fJson.viewName = data.name;
                        data.filterJson = JSON.stringify(fJson);
                        $scope.updateUUidUrl(data.filterJson);
                        if(window.location.href.includes('uuid') && window?.listResponse?.viewName){
                            data.filterJson = JSON.stringify(window.listResponse);
                        }
                        if(privateViewId){
                            $scope.currentView = {
                                id : privateViewId,
                                name: data.name,
                                isdefault: false,
                                manageFilter: true,
                                pinned: false,
                                schedule_count: 0,
                                visibility: "Shared With Me"
                            }
                        }
                        // handled above prior to parsing
                        window.prefMetaDataAvailable = userPref;
                        userPref = $scope.appendMissingFilters(data);
                        defaultFilterLayoutData= userPref.filterJson ? sJq.$.parseJSON(userPref.filterJson):{};
                        let filterJson = $.parseJSON(userPref.filterJson);
                        window.prefViewDetail = {
                            maxNumberOfColumns : filterJson?.selectedColumns?.length,
                            columnsPosition : filterJson?.selectedColumns,
                            maxRecordOnPage : filterJson?.filterMap.size
                        }
                        $scope.searchTextForDT = {value:'',debounce:500};
                        if(filterJson.filterMap && typeof filterJson.filterMap.searchName != "undefined") {
                            $scope.searchTextForDT = {value:filterJson.filterMap.searchName,debounce:500};
                        }

                        if (data == null || data == "") {
                            stopLoader();
                            Toaster.create(intl_msg[7750],{iconClass:"icon-Information_filled"});
                            return;
                        }
                        listJson.columns = userPref.columns;
                        appendCheckBoxColumn(listJson);
                        sortColumns(listJson);
                        const selectedColsFromView = filterJson?.selectedColumns || [];
                        if (selectedColsFromView.length) {
                            const resolvedVisible = selectedColsFromView
                                .map(sel => listJson.columns.find(col => col.id === sel.columnId)
                                    || (sel.columnQueryName ? listJson.columns.find(col => col.queryName === sel.columnQueryName) : undefined))
                                .filter(Boolean);
                            listJson['visibleCols'] = resolvedVisible.length ? resolvedVisible : listJson.columns.slice(0, userPref.maxNumberOfColumns || 8);
                        } else {
                            listJson['visibleCols'] = listJson.columns.slice(0, userPref.maxNumberOfColumns || 8);
                        }
                        listJson.maxNumberOfColumns = userPref.maxNumberOfColumns || 8;
                        listJson = commonUtil.attachColmnGrpObjFromVisibleCols(listJson);
                        $rootScope.viewDataOriginal = angular.copy(listJson);
                        if (data.listViewType) {
                            $rootScope.$emit("fill up list viewType options/value", null, data.listViewType, false);
                        }
                        window.defViewPopulateInstance = $.Deferred();
                        defViewPopulateInstance.promise().then(function (fromLoadView) {
                            try {
                                if (userPref && userPref.filterJson && $.parseJSON(userPref.filterJson) && $.parseJSON(userPref.filterJson).filterMap.size) {
                                    var obj = $.parseJSON(userPref.filterJson);
                                    window.stakeholderObj = obj.filterMap.filterJson[53];
                                    window.keyValueObj = {
                                        '456': obj.filterMap.filterJson[456],
                                        '457': obj.filterMap.filterJson[457]
                                    }
                                    var orderByColumnName = obj.filterMap.orderByColumnName;
                                    var orderDirection = obj.filterMap.orderDirection;
                                    var pageLength = obj.filterMap.size;
                                    var searchText = null;
                                    if(obj.filterMap.searchName){
                                        searchText = obj.filterMap.searchName;
                                    }
                                    //TODO
                                    if ($(".docTreeFilter").length==0 && $("#cr").length && typeof $("#cr").dataTable == "function") {
                                        $("#cr").dataTable()._fnLengthChange(pageLength);
                                    }
                                    listJson["maxRecordOnPage"] = pageLength;
                                    listJson["orderByDefaultName"] = orderByColumnName;
                                    listJson["orderByDefaultDirection"] = orderDirection;
                                    searchText ? listJson["searchName"] = searchText : null;
                                }
                            } catch (e) {
                                if (typeof console != "undefined" && console) {
                                    console.log(e);
                                }
                            }
                            // ----- Process filterListApplied in case filter deleted from admin panel -----
                            let filterListApplied = $.parseJSON(userPref.filterJson).selectedFilterView;
                            let filterMetaDataJsonIds = [];
                            filterMetaDataJson.forEach(filterObj => {
                                filterMetaDataJsonIds.push(filterObj.id);
                            });
                            filterListApplied = filterListApplied && filterListApplied.filter(function(item) {
                                return filterMetaDataJsonIds.includes(item)
                            });
                            // -----------------------------------------------------------------------------
                            if (angular.element("#clause-library").size() > 0) {
                                if ($(".react-filter-btn").length) {
                                    let propsToPass = {
                                        filterMetaDataJson: filterMetaDataJson,
                                        filterData: $.parseJSON(userPref.filterJson).filterMap.filterJson,
                                        filterListApplied,
                                        allFilterData: defaultFilterDataJson,
                                        retainSort: retainSort,
                                        fromLoadView
                                    }
                                    window.sarc.channelBroadcast("loadPreferredView", {
                                        actionType: 'preferredView',
                                        payload: propsToPass
                                    }, 'loadPreferredViewSubscription')
                                } else {
                                    angular.element('.filter-content').each(function (index) {
                                        angular.element(this).populateCustomFilter({
                                            "metaData": filterMetaDataJson,
                                            "data": $.parseJSON(userPref.filterJson).filterMap.filterJson,
                                            "allFilterData": defaultFilterDataJson
                                        });
                                    })
                                }
                            }else {
                                window.redirectionDefaultFilterDataJson = $.parseJSON(userPref.filterJson).filterMap.filterJson
                                if (!$.isEmptyObject(defaultFilterDataJson)){
                                    if($(".react-filter-btn").length){
                                        window.reactFilterLoaded = true;
                                        let propsToPass = {
                                            filterMetaDataJson: filterMetaDataJson,
                                            filterData: window.redirectionDefaultFilterDataJson,
                                            filterListApplied,
                                            allFilterData: defaultFilterDataJson,
                                            retainSort: retainSort,
                                            fromLoadView
                                        }
                                        let mountAt = '#listing-panel-left';
                                        var interval = setInterval(()=>{
                                            if($(mountAt).length) {
                                                clearInterval(interval);
                                                setTimeout(() => {
                                                    if(!$(mountAt).children().length) {
                                                        window.reactComponents.mountDynamicComponent(mountAt,"FilterListingComponent",propsToPass);
                                                        modernListing.updateSelectedFilterCount();
                                                    } else {
                                                        window.sarc.channelBroadcast("loadPreferredView", {
                                                            actionType: 'preferredView',
                                                            payload: propsToPass
                                                        }, 'loadPreferredViewSubscription')
                                                    }
                                                    modernListing.updateSelectedFilterCount();
                                                }, 100);
                                            }
                                        },300)
                                    } else {
                                        $('.filter-content').populateCustomFilter({
                                            "metaData": filterMetaDataJson,
                                            "data": $.parseJSON(userPref.filterJson).filterMap.filterJson,
                                            "allFilterData": defaultFilterDataJson
                                        }, undefined, undefined, undefined, true);
                                    }
                                }

                            }
                            $scope.onCallTotalCount = null;
                            $scope.hideLoader=false;
                            if($scope.showWorkSpaceViewData) {
                                $scope.showWorkSpaceViewData.lowerBound = 0;
                                $scope.showWorkSpaceViewData.upperBound = 0;
                                $scope.showWorkSpaceViewData.lastUpperBound = 0;
                                $scope.showWorkSpaceViewData.offset = 0;
                            }
                            $scope.paginatedfilteredCount = null;
                            if(!$(".react-filter-btn").length){
                                $scope.loadViewCallback();
                            }
                        });
                        if (!_.isEmpty(defaultFilterDataJson)) {
                            defViewPopulateInstance.resolve();
                            delete window.defViewPopulateInstance;
                        } else {
                            if($scope.isReportFilter && typeof $scope.initToggleReportFilters === 'function'){
                                $scope.initToggleReportFilters(undefined,true).then(() => {
                                    defViewPopulateInstance.resolve(true);
                                    delete window.defViewPopulateInstance;
                                })
                            } else if (typeof $scope.initFilters === 'function'){
                                $scope.initFilters(undefined,true,undefined,true).then(() => {
                                    defViewPopulateInstance.resolve(true);
                                    delete window.defViewPopulateInstance;
                                })
                            } else {
                                defViewPopulateInstance.resolve(true);
                                delete window.defViewPopulateInstance;
                            }
                        }
                    });
                    typeof BU != "undefined" && BU.cancelCurrentProcess(true, $scope.isShimmer);
                }

                $scope.$on("loadViewCallbackEvt", function () {
                    $scope.loadViewCallback()
                })

                $scope.loadViewCallback = function(){
                    $scope.fixFilterData();
                    if(!$(".react-filter-btn").length) getNewFilters(true, angular.element(".originalList.modernListing"),null,null,true) ;
                    loadTableHeaders();

                    if(userPref.filterJson && JSON.parse(userPref.filterJson) && JSON.parse(userPref.filterJson).filterMap){
                        var fMap = JSON.parse(userPref.filterJson).filterMap;
                        if(fMap && fMap.filterJson && fMap.filterJson['448']){
                            window.filterDataJson['448'] =fMap.filterJson['448'];
                        }
                    }
                    if ($("#clause-library").size() > 0)
                        $rootScope.$emit("loadClausePreferences");
                    var listSc = $('#contentWrap').length ? $('#contentWrap').scope() : null;
                    if($scope.showWorkspaceView)
                        $scope.initialiseWorkspaceListing();
                    else if($scope.docTreeFilterPage){
                        var scope = $(".Filter-detail").scope();
                        loadTree(scope.currentRelationId, undefined, true, scope.data.id.values,true);
                    }
                    else {
                        if($scope.isReportFilter) {
                            loadDataTable(true);
                            getChartNewData(listId, null,listJson);
                        }
                        else modernListing.loadDataTable()
                    }
                    stopLoader();
                    angular.element("#ajaxloading").hide();
                    angular.element("#overlay").remove();
                    $scope.viewModified = false;
                    $rootScope.$broadcast('reCompileFilters');
                    $scope.setPreferredView('byMe');

                    // if (!_.isEmpty(defaultFilterDataJson)) {
                    //     defViewPopulateInstance.resolve();
                    //     delete window.defViewPopulateInstance;
                    // }
                    //to open saveAS ribbon when view is shared
                    $scope.isViewShared = false;
                    if((window.location.href.indexOf("preferredViewId") > -1 || ($scope.isReportFilter && $rootScope.sharedViewIdReport)) && $scope.viewSharedFirst){
                        $scope.viewSharedFirst = false;
                        $scope.isViewShared = !$scope.isViewShared;
                    }

                }

                $rootScope.appendMissingFilters = (data,specialCase) => {
                    if(data.filterJson) {
                        let filterJSON = !specialCase ? JSON.parse(data.filterJson) : data.filterJson;
                        _.forEach(filterDefaultDataJson, function(value, key) {
                            if(!filterJSON.filterMap.filterJson.hasOwnProperty(key)) {
                                filterJSON.filterMap.filterJson[key] = value;
                            }
                        });
                        if(!specialCase)
                            data.filterJson = JSON.stringify(filterJSON);
                    }
                    return data;
                }

                // This function will help to maintain the checked/un-checked state of [include,does not have] checkboxes.
                $scope.fixFilterData = () => {
                    /*
                    * checkbox-type : 1 => include
                    * checkbox-type : 2 => blank
                    * checkbox-type : 3 => does not have
                    * */
                    let filterJson = _.get(defaultFilterLayoutData,"filterMap.filterJson");
                    if(filterJson) {
                        $.each($("#left_menu .filter-content .extra-options input"), function () {
                            let filterId = $(this).attr('filter-id'),
                                checkboxType = $(this).attr('checkbox-type');
                            if (filterJson[filterId]) {
                                if (checkboxType == '3' && filterJson[filterId].operator == 'not') {
                                    $scope.tickCheckbox(this, filterId);
                                } else if (checkboxType == '1' && filterJson[filterId].operator == 'and') {
                                    $scope.tickCheckbox(this, filterId);
                                }
                            }
                        });
                    }
                }
                $scope.tickCheckbox = (that,filterId) => {
                    $('.extra-options-input[filter-id = "'+filterId+'"]').prop('checked', false);
                    $(that).prop('checked', false);
                    that.checked = true;
                }
                $scope.setViewAsDefault = (e, view) => {
                    e.stopPropagation();
                    e.preventDefault();
                    let maxHeaders = $('#cr:visible>thead th').size()
                    let pref = {};
                    if(!view){
                        const selectedView = $scope.allViews.find(function (viewObj) {
                            return viewObj.isdefault;
                        });
                        $scope.defaultView = selectedView

                    }
                    if ($("#clause-library").size() > 0 && (window.listViewTypeSelected.id == 2)) {
                        let reqData = stringify_datatable_json(true);
                        let reqDataJson = jQuery.parseJSON(reqData);
                        let filterJsonForCategories = getNewFilters(false, $("#left_menu"));
                        reqDataJson.filterMap.filterJson = filterJsonForCategories;
                        reqDataJson.filterMap.offset = 0;
                        reqDataJson.filterMap.limit = 200;
                        reqDataJson.filterMap.orderByColumnName = null;
                        reqDataJson.filterMap.orderDirection = null;
                        reqData = JSON.stringify(reqDataJson);
                        pref.filterJson = reqData;
                        pref.maxNumberOfColumns = 20;
                    } else {
                        if(!_.isEmpty(angular.element(".reportViewContainer")))
                            getNewFilters(false,angular.element(".reportViewContainer"));
                        else
                            getNewFilters(false, angular.element(".originalList.modernListing"));
                        pref.filterJson = stringify_datatable_json(false);
                        pref.maxNumberOfColumns = maxHeaders || 8;
                    }
                    let viewForSystemDefault = {}
                    if($scope.systemDefaultViewLoaded) {
                        viewForSystemDefault = userListMetaData.find(d => d.isdefault)
                    }
                    if (!_.isEmpty($scope.defaultView) && !view) {
                        flag = false;
                        pref.id = $scope.defaultView.id;
                        pref.name = $scope.defaultView.name;
                        pref.publicVisibility = ["Shared By Me", "Shared With Me"].indexOf($scope.defaultView.visibility) > -1 ? true : false;
                    } else if($scope.systemDefaultViewLoaded && !_.isEmpty(viewForSystemDefault) && !view) {
                        flag = false;
                        pref.id = viewForSystemDefault.id;
                        pref.name = viewForSystemDefault.name;
                        pref.publicVisibility = ["Shared By Me", "Shared With Me"].indexOf(viewForSystemDefault.visibility) > -1 ? true : false;
                    } else {
                        pref.id = view.id;
                        pref.name = view.name;
                        pref.publicVisibility = ["Shared By Me", "Shared With Me"].indexOf(view.visibility) > -1 ? true : false;
                        flag = true;
                        if (!$scope.isReportFilter) {
                            commonUtil.removePinnedElement(view.id);
                        }
                    }
                    pref.listId = listId;
                    angular.element(this).closest('.preferViewSection').parent('li').addClass('selected');
                    pref.listViewType = window.listViewTypeSelected;
                    if (pref.listViewType)
                        delete pref.listViewType.$$hashKey;

                    pref.columns = listJson.columns;
                    $scope.doubleDropDown = false;

                    const url = addtStamp(apiVersioning.getApiDynamicVersion($scope.urlController + "_userDefault",listId ) + "/userpreferences/saveDefaultUserPreference?preferenceId=" + pref.id + "&isDefault=" + flag);
                    if (listId && pref.id) {
                        $http.post(url).then(function successCallback(data) {
                            if (data && data.message != undefined && data.message != null) {
                                SirionUtils.openSirionDialogs({popupType: 'alert', str: data.message, heading: intl_msg[24153]});
                            } else {
                                const isAskMiraPage = window.conditionCheck?.isAskMiraPage();
                                const payload = isAskMiraPage ? { search3Dot0: true } : undefined; //send this object as payload for AskMira page
                                let url = addtStamp(apiVersioning.getApiDynamicVersion($scope.urlController+ "_userPreference",listId) + "/userPreference");
                                $http.post(url, payload).then(function successCallback(response) {
                                    if (response.status == 200) {
                                        let data = response.data;
                                        $scope.updateViewListing(data, 1);
                                        setTimeout(function () {
                                            angular.element(".disabledClick").removeClass("disabledClick");
                                            if (!_.isEmpty($scope.currentView)) {
                                                angular.element("li[data-mod-id=" + $scope.currentView.id + "]").addClass('disabledClick');
                                                $scope.showResetView = true;
                                            } else {
                                                angular.element(".resetView").addClass('disabledClick');
                                                $scope.showResetView = false;
                                            }
                                        });

                                        if (view && view.visibility === "Shared With Me") {
                                            Toaster.create(parseStr(intl_msg[7744], "<strong>" + view.name + "</strong>"),{iconClass:"icon-Information_filled"});
                                        } else if(!view) {
                                            Toaster.create(intl_msg[7745],{iconClass:"icon-Information_filled"});
                                        }else {
                                            Toaster.create(parseStr(intl_msg[7746], "<strong>" + view.name + "</strong>"),{iconClass:"icon-Information_filled"});
                                        }
                                    }
                                    stopLoader();$(".modtip").remove();
                                });
                            }
                        })
                    } else {
                        Toaster.create(intl_msg[28867]);
                    }

                }


                $scope.unpinView = (e, view) => {
                    e.stopPropagation();
                    view.pinned = false;
                    $(".pin_view_node").removeClass("active");
                    $(".pinned_views").removeClass("not_modified");
                    $http.post("/listRenderer/list/" + listId + "/" + view.id + "/deletePinPreference").then(function successCallback(d) {
                        $scope.setPreferenceData(_.without($scope.preferenceDataItems, _.find($scope.preferenceDataItems, {
                            id: view.id
                        })));
                        $('li[data-mod-id="' + view.id + '"]').find(".pin").removeClass("icon-unpin").addClass('icon-pin');
                        $('li[data-mod-id="' + view.id + '"]').find(".pin").attr("data-mod-title", intl_msg[25735]);
                        view.pinned = false;
                        $(".modTooltip").remove();
                        $scope.$$postDigest(function () {
                            commonUtil.setListTableHeight();
                        })
                    })
                }

                $scope.pinView = (e, view) => {
                    e.stopPropagation();
                    let pref = view;
                    let itemIndex = $scope.allViews.findIndex(function (v) {
                        return v.id === view.id;
                    });
                    view.pinned = true;
                    $scope.allViews[itemIndex] = view;
                    let url = apiVersioning.getApiDynamicVersion($scope.urlController)  + listId + "/" + pref.id + "/pinPreference";
                    $http.post(url).then(function successCallback(d) {
                        pref.pinned = true;
                        let s = $('#contentWrap').scope();
                        s.preferenceDataItems.splice(0, 0, pref);
                        if (!s.$$phase) {
                            s.$apply();
                        }
                        angular.element(e).addClass('icon-unpin').removeClass('icon-pin').attr('data-mod-title', intl_msg[25736]);
                        if ($("li.disabledClick[data-mod-id=" + pref.id + "]").length) {
                            commonUtil.markActiveView(pref.id);
                        }
                        $scope.$$postDigest(function () {
                            commonUtil.setListTableHeight();
                        })
                    });
                }

                $scope.deletePreference = (e, view) => {
                    e.stopPropagation();
                    let name = view.name
                    let publicVisibility = ["Shared By Me", "Shared With Me"].indexOf(view.visibility) > -1 ? true : false;
                    const args = {
                        popupType: 'confirm',
                        str: intl_msg[6488],
                        heading: intl_msg[25772],
                        yesCbFn: function () {
                            var customListId = listId, pref = {};
                            let url = apiVersioning.getApiDynamicVersion($scope.urlController + "_deletePreference",customListId ) +  "/deleteUserPreference?preferenceId=" + view.id + "&publicVisibility=" + publicVisibility;
                            window.startLoader();
                            $http.post(url).then(function successCallback(response) {
                                let status = response.status;
                                if(status == 200){
                                    let data = response.data;
                                    stopLoader();
                                    commonUtil.removePinnedElement(view.id);
                                    $scope.updateViewListing(data,1);
                                    if (!window.conditionCheck.isSearchResultPage()) {
                                        if(!_.isEmpty($scope.defaultView)){
                                            $scope.currentView = $scope.defaultView;
                                            $scope.loadView(e,$scope.defaultView);
                                        } else {
                                            $scope.currentView = "";
                                            $scope.loadView(e);
                                        }
                                    }
                                    angular.element("#cancelSettings").length && $scope.cancelSetting(e,true);;

                                    if (data.length == 0) {
                                        setTimeout(function () {
                                            angular.element(".reset").click();
                                        });
                                    }
                                    Toaster.create(intl_msg[23549]);
                                } else{
                                    if (status == 700) {
                                        SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[23603], heading: intl_msg[24153]});
                                        stopLoader();
                                    }
                                }
                            }).finally(() => window.stopLoader());

                        },
                        noCbFn: function () {
                            return false;
                        }
                    }
                    SirionUtils.openSirionDialogs(args);
                }
                $scope.closeSaveAsPopUp = true;
                $scope.nameLengthError = false;
                $scope.saveSetting = (e) => {
                    var name = $scope.nameToSave.value.trim();
                    var customListId = listId, pref = {};
                    var result = regexForSpecial.test(name);
                    if(!$scope.rolePublicFilter){
                        $scope.viewTypeToSave = 'private';
                    }
                    if (name == "") {
                        $scope.prefrenceNameErrorFlag = true;
                        //Toaster.create(intl_msg[23544]);
                        return false;
                    } else if (result == false) {
                        SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[23545], heading: intl_msg[24153]});
                        $scope.nameToSave = {'value': ""};
                        return false;
                    } else if (name == intl_msg[23718]){
                        SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[23605], heading: intl_msg[24153]});
                        $scope.nameToSave = {'value': ""};
                        return false;
                    }
                    if (name != "") {
                        var maxHeaders = $rootScope.isCognitiveListing ? listJson?.visibleCols?.length : angular.element("#cr:visible>thead th").size();
                        var listSc = $('#contentWrap').length ? $('#contentWrap').scope() : null;
                        if (angular.element("#clause-library").size() > 0 && (window.listViewTypeSelected.id == 2)) {
                            if (listSc && listSc.showWorkspaceView)
                                var reqData = stringify_datatable_json(true, undefined, undefined, true);
                            else
                                var reqData = stringify_datatable_json(true);
                            var reqDataJson = jQuery.parseJSON(reqData);
                            var filterJsonForCategories = getNewFilters(false, $("#left_menu"),null,null,null,true);
                            reqDataJson.filterMap.filterJson = filterJsonForCategories;
                            reqDataJson.filterMap.offset = 0;
                            reqDataJson.filterMap.limit = 200;
                            reqDataJson.filterMap.orderByColumnName = null;
                            reqDataJson.filterMap.orderDirection = null;
                            reqData = JSON.stringify(reqDataJson);
                            pref.filterJson = reqData;
                            pref.maxNumberOfColumns = 20;
                        } else {
                            if(!_.isEmpty(angular.element(".reportViewContainer"))){
                                getNewFilters(false,angular.element(".reportViewContainer"),null,null,null,true);
                            } else {
                                getNewFilters(false, angular.element(".originalList.modernListing"),null,null,null,true);
                            }
                            if (listSc && listSc.showWorkspaceView)
                                pref.filterJson = stringify_datatable_json(false, undefined, undefined, true);
                            else
                                pref.filterJson = stringify_datatable_json(false);
                            pref.maxNumberOfColumns = maxHeaders || 8;
                        }

                        // Set searchName filter value
                        if($scope.searchTextForDT && !!$scope.searchTextForDT.value){
                            pref.filterJson = JSON.parse(pref.filterJson);
                            pref.filterJson.filterMap.searchName = $scope.searchTextForDT.value;
                            pref.filterJson = JSON.stringify(pref.filterJson);
                        }

                        if (listSc && listSc.showWorkspaceView) {
                            var filterJsonObj = JSON.parse(pref.filterJson);
                            pref.maxNumberOfColumns = 3;
                        }
                        pref.listId = customListId;
                        pref.name = name;
                        flag = true;
                        pref.columns = listJson.columns;
                        pref.listViewType = window.listViewTypeSelected;
                        if (pref.listViewType)
                            delete pref.listViewType.$$hashKey;
                        setCheckBoxObject(listJson);
                        $scope.viewTypeToSave === 'public' ? pref.publicVisibility = true : pref.publicVisibility = false;

                        if($(".react-filter-btn").length){
                            pref.filterJson = JSON.parse(pref.filterJson);
                            window.prefViewDetail.maxNumberOfColumns = pref.maxNumberOfColumns;
                            window.prefViewDetail.columnsPosition = pref.filterJson.selectedColumns;
                            if(window.selectedFilterView && window.selectedFilterView.length) pref.filterJson.selectedFilterView = window.selectedFilterView;
                            let dataToSend = {};
                            if(window.processedFilterData) {
                                Object.keys(window.processedFilterData).forEach(filter => {
                                    dataToSend[filter] = $scope.updateFilterIfNeeded(window.processedFilterData[filter]);
                                })
                            }
                            pref.filterJson.filterMap.filterJson = dataToSend;
                            let payload = {};
                            if(pref.listId == 271 || pref.listId == 361){
                                payload = window.copyOfPayload &&  window.copyOfPayload.filterMap && window.copyOfPayload.filterMap.filterJson &&  window.copyOfPayload.filterMap.filterJson;
                            } else {
                                payload = window.payload && window.payload.filterMap && window.payload.filterMap.filterJson && window.payload.filterMap.filterJson;
                            }
                            if(!_.isEmpty(payload)){
                                _.forEach(payload, _payload => {
                                    if(_.has(_payload, "filterId")){
                                        let id = _payload.filterId;
                                        pref.filterJson.filterMap.filterJson[id] = _payload;
                                    }
                                });
                            }
                            pref.filterJson = JSON.stringify(pref.filterJson);
                            if(window.reactFilterLoaded) $scope.resetFilter();
                        }

                        if($rootScope.isCognitiveListing) {
                            pref.filterJson = JSON.parse(pref.filterJson);
                            const sortingColumn = window.resultPageListingData[listId]?.sortingColumn;
                            pref.filterJson.filterMap.orderByColumnName = sortingColumn ? sortingColumn.field : pref.filterJson.filterMap.orderByColumnName;
                            pref.filterJson.filterMap.orderDirection = sortingColumn ? sortingColumn.sort : pref.filterJson.filterMap.orderDirection;
                            pref.filterJson = JSON.stringify(pref.filterJson);
                        }

                        // Add search3dot0 flag for AskMira page
                        if (window.conditionCheck?.isAskMiraPage()) {
                            pref.search3Dot0 = true;
                            if ($scope.pinnedColumnsToUpdate) {
                                pref.pinnedColumns = $scope.pinnedColumnsToUpdate;
                                delete $scope.pinnedColumnsToUpdate;
                            }
                        }

                        if (name.length < 256) {
                            var isExist = false;
                            let nm = $scope.allViews && $scope.allViews.find(function (v) {
                                return v.name.toLowerCase() == name.toLowerCase();
                            }) || null;
                            if(!_.isEmpty(nm)){
                                isExist = true;
                            }
                            if (isExist) {
                                $scope.nameToSave = {'value':""};
                                stopLoader();
                                Toaster.create(intl_msg[23552],{iconClass:"icon-Information_filled"});
                                return;
                            } else {
                                if (_.isEmpty(angular.element(".reportViewContainer"))) {
                                    modernListing.temporarySaveSetting(JSON.parse(typeof pref.filterJson == 'string' && pref.filterJson), "", false);
                                }
                                let url = apiVersioning.getApiDynamicVersion($scope.urlController + "_save",customListId);
                                return $http.post(url,JSON.stringify(pref))
                                    .then( function (response) {
                                        let status = response.status;
                                        if(status == 200){
                                            $rootScope.viewLoaded = true;
                                            if($rootScope.isCognitiveListing || $scope.$location.$$search.uuid) {
                                                $scope.myViewChanged = true;
                                            }
                                            $scope.nameLengthError = false;
                                            //now flag for showing modified ribbon will be assigned to false only after a view is saved
                                            $scope.viewModified = false;
                                            let data = response.data;
                                            if($rootScope.isCorpusPage) {
                                                window.userListMetaData = data;
                                                window.isArkSirionViewPresent = true;
                                            }
                                            commonUtil.markActiveView();
                                            $scope.viewTypeToSave==='public' ? pref.publicVisibility = true : pref.publicVisibility = false;
                                            $scope.updateViewListing(data);
                                            var viewVal = $scope.nameToSave.value.trim();
                                            $scope.viewTypeToSave = 'private';
                                            $scope.radio.saveType.value = 'private';
                                            $scope.nameToSave = {'value':""};
                                            $scope.currentView = $scope.allViews.find(function (v) {
                                                return v.name == name;
                                            });
                                            $scope.viewToShare = $scope.currentView;
                                            if(!$scope.currentView.isdefault){
                                                $scope.showResetView = true;
                                            }
                                            $scope.radio.viewType.value = 'byMe';
                                            stopLoader();
                                            $("body").click();
                                            if($rootScope.isCognitiveListing) {
                                                Toaster.create(intl_msg[35977] || "View saved successfully and accessible in the entity's listing");
                                                window.resultPageListingData[listId].viewStatus = "Saved";
                                                window.resultPageListingData[listId].initialFilterOptions = JSON.parse(JSON.stringify(window.processedFilterData));
                                                window.resultPageListingData[listId].columns = JSON.parse(JSON.stringify(window.listJson.columnsGroup));
                                                window.resultPageListingData[listId].statusViewName = name;
                                                $scope.resultViewsStatus = 'Saved';
                                                $scope.statusViewName = name;
                                                const propsToPass = {
                                                    initialFilterOptions: window.resultPageListingData[listId].initialFilterOptions
                                                }
                                                window.sarc.channelBroadcast("loadPreferredView", {
                                                    actionType: 'updatedResultPageInitialData',
                                                    payload: propsToPass
                                                }, 'loadPreferredViewSubscription')
                                            } else if(!$rootScope.isCorpusPage) {
                                                Toaster.create(intl_msg[23548]);
                                            }
                                            setTimeout(function(){
                                                angular.element(".disabledClick").removeClass("disabledClick");
                                                angular.element("li[data-mod-id=" + $scope.currentView.id + "]").addClass('disabledClick');
                                            },0);
                                            $rootScope.viewDataOriginal = angular.copy(listJson);
                                        } else {
                                            if (status == 810) {
                                                SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[23547], heading: intl_msg[24153]});
                                            }
                                            else if (status == 600) {
                                                SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[23552], heading: intl_msg[24153]});
                                            }
                                            else if (status == 700) {
                                                SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[7748], heading: intl_msg[24153]});
                                            }
                                            else if(status==811) {
                                                $scope.showLimitExceedMessage = (intl_msg[28988]).replace("%s", response.data[0]);
                                                SirionUtils.openSirionDialogs({popupType: 'alert', str: (intl_msg[28988]).replace("%s", response.data[0]), heading: intl_msg[24153]});
                                            }
                                            else if(status==419) {
                                                $scope.showLimitExceedMessage = response.data[0].errorMessage;
                                                SirionUtils.openSirionDialogs({popupType: 'alert', str: response.data[0].errorMessage, heading: intl_msg[24153]});
                                            }else if(status == 401 || status == 403){
                                                Toaster.create(response?.data[0]?.errorMessage || intl_msg[23606],{iconClass:"icon-Information_filled"})
                                            }
                                            stopLoader();

                                        }
                                    });
                            }
                        } else {
                            $scope.nameLengthError = true;
                            Toaster.create(intl_msg[23547],{iconClass:"icon-Information_filled"});
                            stopLoader();
                            return;
                        }
                        $scope.closeSaveAsPopUp = false;
                    }
                    $scope.openSavedView();
                }

                $scope.setVisibilityOfViewToSave = (viewType) => {
                    if (viewType == "private") {
                        $scope.viewTypeToSave = 'private';
                        // angular.element('#privateBtnRadio').prop("checked", true);
                        $scope.radio.saveType.value = 'private';
                    } else {
                        $scope.viewTypeToSave = 'public';
                        // angular.element('#publicBtnRadio').prop("checked", true);
                        $scope.radio.saveType.value = 'public';
                    }
                }

                $scope.editView = (e,view) =>{
                    $scope.editViewObj = view;
                    editViewArr[0] = view.name;
                    editViewArr[1] =["Shared By Me", "Shared With Me"].indexOf(view.visibility) > -1 ? true : false;
                    editViewArr[2] = view.id;
                    $scope.nameToSave.value = view.name;
                    setTimeout(function () {
                        $scope.loadView(e,view);
                    });
                    var _editViewText = intl_msg[29085]||"Edit View";
                    angular.element(".viewSection.create").addClass("editMode").find(".title").html(_editViewText);
                    angular.element('.viewSection.create .title.list-toolbar-text').attr('title',_editViewText);
                    angular.element("body").click();
                    setTimeout(function () {
                        var elem = $(".viewSection.create");
                        $scope.radio.saveType.value = editViewArr[1] ? 'public' : 'private';
                        angular.element(".viewSection").removeClass("selected");
                        elem.click();
                        elem.addClass('selected');
                        elem.addClass("clickOnBodyClick");
                        elem.find(".createView.search").focus();
                        elem.find(".createView.search").val(editViewArr[0]);
                        $scope.saveMode = false;
                        $scope.updateMode = true;
                        angular.element(".disabledClick").removeClass("disabledClick");
                        angular.element("li[data-mod-id=" + view.id + "]").addClass('disabledClick');
                    }, 500);
                }

                $scope.cancelSetting = (e, dontRemoveURLParam) =>{
                    e && e.stopPropagation();
                    $scope.nameLengthError = false;
                    $scope.onCallTotalCount = null;
                    if($scope.searchTextForDT?.value){
                        $scope.clearSearchText();
                    }
                    if($scope.$location.$$search.uuid && !dontRemoveURLParam) {
                        const updatedUrl = window.SirionUtils.removeURLParameter(window.location.href, "uuid")
                        window.location.replace(updatedUrl);
                        window.cancelViewBanner = true;
                    }
                    angular.element(this).closest(".createViewDD").find(".search").val("");
                    angular.element(".viewSection.create").removeClass("editMode")
                    angular.element(".viewSection.create .title").attr('title',intl_msg[27944]).html(intl_msg[27944]);
                    angular.element("#viewTypePrivate").prop("checked", true);
                    setTimeout(function () {
                        angular.element("body").click();
                        $scope.updateMode = false;
                        $scope.saveMode = true;
                        $scope.prefrenceNameErrorFlag = false;
                        $scope.nameToSave = {'value':""};
                        if($scope.viewModified){
                            if(!_.isEmpty($scope.defaultView) && _.isEmpty($scope.currentView)){
                                $scope.loadView(e,$scope.defaultView);
                            }
                            else if(!_.isEmpty($scope.currentView)){
                                typeof BU != "undefined" && BU.cancelCurrentProcess(true);
                                if ($(".react-filter-btn")) {
                                    $scope.loadView(e, $scope.currentView, null, true);
                                }
                                else {
                                    angular.element(".reset").click();
                                }

                            } else {
                                if ($('#cr').length > 0 && $(".react-filter-btn").length > 0 && !window.reactFilterLoaded) {
                                    var scope = $("filters").scope();
                                    scope && scope.$emit("listing skeleton toggle", true, false);
                                    scope && scope.clickOnResetBtn("",true,$rootScope.viewLoaded);
                                } else if($('#cr').length > 0 && $(".react-filter-btn").length > 0){ //reset functionality when there is change in only filters
                                    window.sarc.channelBroadcast("loadReactFiltersForDefaultView", {
                                        actionType: 'cancelSettingsForView',
                                    }, 'loadReactFiltersForDefaultViewSubscription')
                                } else {
                                    angular.element(".reset").click();
                                }
                            }
                            $scope.viewModified = false;
                        }
                    }, 100);
                    $(".modTooltip").remove();
                    //to close saveAS ribbon when view is shared
                    $scope.isViewShared = false;
                    delete $rootScope.sharedViewIdReport;
                }

                $scope.cancelResultSetting = e => {
                    e && e.stopPropagation();
                    window.resetResultPageListing = true;
                    if ($('#cr').length > 0 && $(".react-filter-btn").length > 0 && !window.reactFilterLoaded) {
                        var scope = $("filters").scope();
                        scope && scope.$emit("listing skeleton toggle", true, false);
                        scope && scope.clickOnResetBtn("",true,$rootScope.viewLoaded);
                        $scope.loadView(e, null, null, true);
                    } else if($('#cr').length > 0 && $(".react-filter-btn").length > 0){ //reset functionality when there is change in only filters
                        window.sarc.channelBroadcast("loadReactFiltersForDefaultView", {
                            actionType: 'cancelSettingsForView',
                        }, 'loadReactFiltersForDefaultViewSubscription')
                    }
                    window.resultPageListingData[listId].viewStatus = "Saved";
                    $scope.resultViewsStatus = "Saved";
                    $scope.updateGlobalFilter(window.resultPageListingData[listId].initialFilterOptions)
                }

                $scope.resetFilter = () => {
                    if($(".react-filter-btn") && window.reactFilterLoaded) {
                        window.sarc.channelBroadcast("loadReactFiltersForDefaultView", {
                            actionType: 'saveUpdatedFilterView',
                        }, 'loadReactFiltersForDefaultViewSubscription')
                    }
                }

                $scope.updateFilterIfNeeded = (field) => {
                    if(!field) return;
                    let type = field.uiType || field.uitype;

                    let hasValue = true;
                    const validOperator = field.operator && !["NOT","AND"].includes(field.operator);
                    const emptyValues = [null,'',undefined];
                    if(!type) hasValue = false;
                    else if(type == "DATE" &&
                        ((!field["startDate"] && !field['endDate'] && !field["start"] && !field["end"]  && emptyValues.includes(field["dayOffset"]) && emptyValues.includes(field["duration"])) ||
                            (!emptyValues.includes(field["dayOffset"]) && !emptyValues.includes(field["duration"]) && field["duration"] < 0) ) &&
                        !validOperator){
                        hasValue = false;
                        if(field["start"] === "") field["start"] = null;
                        if(field["end"] === "") field["end"] = null;
                    }
                    else if((type == "MULTISELECT" || type == "SINGLESELECT" || type == "STATUS" || type == "STAKEHOLDER" || type == "KEYVALUE")){
                        if((!field["multiselectValues"] || !field["multiselectValues"]["SELECTEDDATA"] || field["multiselectValues"]["SELECTEDDATA"].length == 0) && !validOperator) {
                            hasValue = false;
                        }
                    }
                    else if((type == "TEXTRANGE" || type == "SLIDER" || type == "INPUTTEXT") && !field["min"]  && !field["max"] && !validOperator){
                        hasValue = false;
                    }
                    if(!hasValue && ["NOT","AND"].includes(field.operator)) {
                        delete  field.operator;
                    }
                    if(!hasValue && type == "DATE") {
                        if(_.has(field, "multiselectValues") && _.has(field.multiselectValues, "SELECTEDDATA")) field.multiselectValues.SELECTEDDATA = [];
                    }
                    return field;
                }


                $scope.updateSetting = (e,updateCurrentView, options) =>{
                    e.stopPropagation;
                    alreadySavedView = false;
                    var maxHeaders = $("#cr:visible>thead th").size() || $("#cr>thead th").size();
                    var customListId = listId, pref = {};

                    if ($("#clause-library").size() > 0 && (window.listViewTypeSelected.id == 2)) {
                        var reqData = stringify_datatable_json(true, null, null, null, null, null, options?.skipColumnSort);
                        var reqDataJson = jQuery.parseJSON(reqData);
                        var filterJsonForCategories = getNewFilters(false, $("#left_menu"));
                        reqDataJson.filterMap.filterJson = filterJsonForCategories;
                        reqDataJson.filterMap.offset = 0;
                        reqDataJson.filterMap.limit = 200;
                        reqDataJson.filterMap.orderByColumnName = null;
                        reqDataJson.filterMap.orderDirection = null;
                        reqData = JSON.stringify(reqDataJson);
                        pref.filterJson = reqData;
                        pref.maxNumberOfColumns = 20;
                    } else {
                        if(!_.isEmpty($(".reportViewContainer"))){
                            getNewFilters(false,$(".reportViewContainer"));
                        }else{
                            getNewFilters(false,$(".originalList.modernListing"));
                        }
                        pref.filterJson = stringify_datatable_json(false, null, null, null, null, null, options?.skipColumnSort);
                        pref.maxNumberOfColumns = maxHeaders || 8;
                    }
                    pref.listId = customListId;
                    const isSearchResultPage = window.conditionCheck.isSearchResultPage();
                    const foundView = $scope.allViews.find(view => view.name == $scope.statusViewName);
                    const isCurrentViewEmpty = typeof $scope.currentView == 'undefined' || _.isEmpty($scope.currentView);
                    const isFoundViewEmpty = typeof foundView == 'undefined' || _.isEmpty(foundView);
                    if (isSearchResultPage && isCurrentViewEmpty && !isFoundViewEmpty) {
                        $scope.currentView = foundView;
                    }
                    let name = "";
                    if (updateCurrentView) {
                        if ($scope.currentView) {

                            name = $scope.currentView.name;
                        }
                    } else {

                        // name = $("#settingName").val().trim();
                        name = $scope.nameToSave.value.trim();
                    }
                    if (name == "") {
                        stopLoader();
                        SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[23544], heading: intl_msg[24153]});
                        return false;
                    }
                    let viewType = "";

                    if(updateCurrentView){
                        pref.id = $scope.currentView.id;

                    } else {
                        $scope.currentView = $scope.editViewObj;
                        pref.id = $scope.editViewObj.id;

                    }
                    let prefId =pref.id;
                    pref.name = name;
                    flag = true;
                    pref.columns = listJson.columns;
                    pref.listViewType = window.listViewTypeSelected;
                    if (pref.listViewType){
                        delete pref.listViewType.$$hashKey;
                    }
                    setCheckBoxObject(listJson);
                    pref.publicVisibility = $scope.currentView.visibility != 'Shared By Me' ? false : true;
                    setTimeout(function(){commonUtil.renameCurrentActiveView(pref.name, pref.id);});
                    if(!$scope.isReportFilter){
                        pref.filterJson =  $scope.addRemoveSearchTextFromFilterMap(pref.filterJson);
                    }

                    if($(".react-filter-btn").length){
                        pref.filterJson = JSON.parse(pref.filterJson);
                        window.prefViewDetail.maxNumberOfColumns = pref.maxNumberOfColumns;
                        window.prefViewDetail.columnsPosition = pref.filterJson.selectedColumns;
                        let dataToSend = {};
                        if(window.processedFilterData) {
                            Object.keys(window.processedFilterData).forEach(filter => {
                                dataToSend[filter] = $scope.updateFilterIfNeeded(window.processedFilterData[filter]);
                            })
                        }
                        pref.filterJson.filterMap.filterJson = dataToSend;
                        if(window.selectedFilterView && window.selectedFilterView.length) pref.filterJson.selectedFilterView = window.selectedFilterView;
                        let payload = {};
                        if(pref.listId == 271 || pref.listId == 361){
                            payload = window.copyOfPayload && window.copyOfPayload.filterMap && window.copyOfPayload.filterMap.filterJson && window.copyOfPayload.filterMap.filterJson;
                        } else {
                            payload = window.payload && window.payload.filterMap && window.payload.filterMap.filterJson && window.payload.filterMap.filterJson;
                        }
                        if(!_.isEmpty(payload)) {
                            _.forEach(payload, _payload => {
                                if(_.has(_payload, "filterId")){
                                    let id = _payload.filterId;
                                    pref.filterJson.filterMap.filterJson[id] = _payload;
                                }
                            });
                        }
                        if (_.isEmpty(angular.element(".reportViewContainer"))) {
                            modernListing.temporarySaveSetting(pref.filterJson, "", false);
                        }
                        pref.filterJson = JSON.stringify(pref.filterJson);
                        if(window.reactFilterLoaded) $scope.resetFilter();
                    }

                    // Add pinned columns and search3Dot0 flag for AskMira page
                    if (window.conditionCheck?.isAskMiraPage()) {
                        pref.search3Dot0 = true;
                        if ($scope.pinnedColumnsToUpdate) {
                            pref.pinnedColumns = $scope.pinnedColumnsToUpdate;
                            delete $scope.pinnedColumnsToUpdate;
                        }
                    }

                    let url =  apiVersioning.getApiDynamicVersion($scope.urlController + "_update",customListId) + "/userpreferences/update";
                    $http.post(url,pref).then(function successCallback (data) {
                        if(data.data && !data.data[0]?.errorMessage) {
                            $rootScope.viewLoaded = true;
                            $scope.viewModified = false;
                            $scope.cancelSetting(e, true);
                            angular.element(".viewSection").find(".DropdownBox").css("opacity", 0).css("visibility", "hidden");
                            $scope.updateViewListing(data.data);
                            if($rootScope.isCognitiveListing) {
                                window.resultPageListingData[listId].viewStatus = "Saved";
                                $scope.resultViewsStatus = "Saved";
                                window.resultPageListingData[listId].initialFilterOptions = JSON.parse(JSON.stringify(window.processedFilterData));
                                window.resultPageListingData[listId].columns = JSON.parse(JSON.stringify(window.listJson.columnsGroup));
                                const propsToPass = {
                                    initialFilterOptions: window.resultPageListingData[listId].initialFilterOptions
                                }
                                window.sarc.channelBroadcast("loadPreferredView", {
                                    actionType: 'updatedResultPageInitialData',
                                    payload: propsToPass
                                }, 'loadPreferredViewSubscription')
                            }
                            angular.element(".disabledClick").removeClass("disabledClick");
                            $("li[data-mod-id=" + prefId + "]").addClass("disabledClick");
                            $scope.currentView= data.data.find(function (v) {
                                return v.name ==name;
                            });
                            stopLoader();
                            if(!$rootScope.isCorpusPage) {
                                Toaster.create(intl_msg[23546]);
                            }
                            $scope.nameToSave = {'value':""};
                        } else if(data?.data[0]?.errorMessage) {
                            Toaster.create(data.data[0].errorMessage,{iconClass:"icon-Information_filled"});
                        }
                    });
                    //to close saveDd when view is updated.
                    $scope.nameLengthError = false;
                    $scope.closeSavedView(e);
                }
                $scope.pinOrUnpinView = (e, view) => {
                    if(!view) return;

                    if (view.pinned) {
                        $scope.unpinView(e, view);
                    } else {
                        $scope.pinView(e, view);
                    }
                }

                $scope.getVisibleViewCount = function (elementId){
                    if(!$(elementId).length)
                        return 0;

                    return $(elementId).children().length;
                }

                $scope.getDropdownText = (viewType) => {
                    if ($scope.allViews) {
                        if (viewType === 'private') {
                            return intl_msg[23713] + " (" + $scope.getVisibleViewCount("#privateDiv") + ")";
                        } else {
                            return intl_msg[23714] + " (" + $scope.getVisibleViewCount("#publicDiv") + ")";
                        }
                    }

                }
                // to toggle view-Modified Ribbon when no preffered-view is present
                $scope.openViewModifiedRibbon = false;
                $scope.removeView = (e) => {
                    $scope.openViewModifiedRibbon = false;
                    $scope.saveViewOpen = false;
                    $scope.isViewShared = false;//to hide shared view ribbon on click of removeView
                    delete  $rootScope.sharedViewIdReport;
                    e.stopPropagation();
                    commonUtil.markActiveView();
                    typeof BU != "undefined" && BU.cancelCurrentProcess(true);
                    $scope.searchTextForDT = {value:'',debounce:0};
                    listJson.searchName = '';
                    if (!_.isEmpty($scope.defaultView)) {
                        $scope.loadView(e, $scope.defaultView);
                    } else {
                        setTimeout(function () {
                            if ($(".react-filter-btn").length) {
                                $scope.loadView(e);
                            } else {
                                angular.element(".reset").click();
                            }
                            //above click functions is defined  in commonDirective but it is not going in that function for reports hence disabledClick class is explicitly removed
                            $(".savedViewDD li.disabledClick").removeClass("disabledClick");
                        });
                        $scope.currentView = {};
                        $scope.showResetView = false;
                    }
                    // $scope.loadView(e);
                    $(".modTooltip").remove();
                }

                $scope.openGroups = () => {
                    angular.element("#privateDiv").show();
                    angular.element("#publicDiv").show();
                }
                var resetViewCleanup = $rootScope.$on('resetCurrentView', function () {
                    $scope.currentView = {};
                    $scope.showResetView = false;
                })

                $scope.$on("$destroy", function (e) {
                    resetViewCleanup();
                });
                $scope.expandClickHandler = function (event) {
                    if($scope.isReportFilter) {
                        event.stopImmediatePropagation();
                        if(angular.element(event.currentTarget).hasClass('selected') != true) {
                            $scope.toggleFilterPanel(false,undefined);
                            $scope.initToggleReportFilters(event).then(function () {
                                $scope.expandHandler(event)
                            });
                        }else{
                            angular.element(event.currentTarget).removeClass("selected");;
                            angular.element(event.currentTarget).find(".DropdownBox").css({"opacity": 0, "visibility": "hidden", "display": "none", "z-index": -1});
                        }

                    }else if($scope.docTreeFilterPage) {
                        $scope.openSaveView(event,false);
                        $scope.showPageService.initDocTreeFilters(event);
                    }else  {
                        if(event.currentTarget.id === "faView"){
                            $scope.initFilters(event);
                            if((angular.element(".viewSection").hasClass('editMode'))){
                                angular.element(".viewSection.create").removeClass("editMode");
                                angular.element(".viewSection.create .title").attr('title',intl_msg[27944]).html(intl_msg[27944]);
                                $scope.updateMode = false;
                                $scope.saveMode = true;
                                $scope.nameToSave = {'value':""};
                                $scope.viewModified = false;
                            }
                        } else if(event.currentTarget.id === "createBtn")
                            $scope.openSaveView(event,false)
                    }
                }


                $scope.expandHandler = function (e) {
                    var that = e.currentTarget;
                    if (e.originalEvent || $(that).hasClass("editMode")) {
                        $('[column-group]').remove();
                        $(".viewSection, .columnsGroupButton").removeClass("selected");
                        $(that).addClass("selected");
                        $(".DropdownBox, .reportColumnContainer").css({"opacity":0,"visibility":"hidden","display":"none","z-index":-1});
                        if($(that).hasClass("workSpacebtn") == false || (e.target && e.target.tagName.toLowerCase() != "li")){
                            setTimeout(function () {
                                $(that).find(".DropdownBox").css({"opacity":1,"visibility":"visible","display":"block","z-index":999999});
                            },0)
                        }
                    }
                }

                $scope.openSaveView = function(e,hide){
                    var scope  = $scope;
                    if($scope.docTreeFilterPage) {
                        scope = $(".Filter-detail").scope();
                    }
                    if(!scope){
                        return;
                    }
                    if(scope.private == undefined || hide){
                        scope.private =true;
                    }
                    var createViewDDRef = e?angular.element(e.target).closest(".createViewDD"):undefined;
                    if(e && createViewDDRef.length){
                        return;
                    }
                    if(createViewDDRef && createViewDDRef.length || hide){
                        $(".viewSection .create").removeClass("selected");
                        return;
                    }
                    if(!e){
                        return;
                    }

                }
                $scope.shareThisView = function(e,v,bool){
                    $scope.viewDd = false;
                    e.stopPropagation();
                    e.preventDefault();
                    $scope.$broadcast('open share view', {event: e,view : v, bool: bool});
                    if($rootScope.isCognitiveListing) {
                        const {leftOffsetModRibbon, topOffsetModRibbon, heightModRibbon} = $scope.getElementPosition()
                        $("#share_filter_container").css({
                            "position": "fixed",
                            "left": leftOffsetModRibbon + "px",
                            "top": topOffsetModRibbon + heightModRibbon + 3 + "px"
                        });
                    }
                }
            }
        }

    }]);
